import { createUseStyles } from "react-jss";
import * as Mixins from "../../../theme/Mixins";

export default createUseStyles({
    page: {
        composes: "page",
        height: "100%",
        color: ({ theme }) => Mixins.foregroundColor(theme, Mixins.wrapperBackgroundColor(theme)),
        transition: "opacity 2000ms",

        "& hr": {
            height: 0,
            border: 0,
            margin: ({ theme }) => [[theme.PageSeparatorsSpacing, 0]],
            borderTop: ({ theme }) =>
                `${theme.PageSeparatorsWidth}px solid ${Mixins.foregroundColor(
                    theme,
                    Mixins.wrapperBackgroundColor(theme),
                )}`,
        },

        "& img, video": {
            maxWidth: "100%",
        },

        "& fieldset": {
            display: "block",
            border: 0,
            margin: 0,
            padding: 0,
            "& legend": {
                margin: 0,
                padding: 0,
            },
        },

        "& .non-fieldset-grouping-question": {
            display: "block",
            border: 0,
            margin: 0,
            padding: 0,
            "margin-inline-start": "2px",
            "margin-inline-end": "2px",
            "padding-block-start": "0.35em",
            "padding-block-end": "0.625em",

            "& div.question__legend": {
                margin: 0,
                padding: 0,
                display: "block",
                "padding-inline-start": "2px",
                "padding-inline-end": "2px",
                "unicode-bidi": "isolate",
                "border-width": "initial",
                "border-style": "none",
                "border-color": "initial",
                "border-image": "initial",
            },
        },
    },
    pageWrapper: {
        composes: "page__wrapper",
        minHeight: "100%",
        margin: [[0, "auto"]],
        padding: ({ theme }) =>
            theme.TopNavigationPosition === "floating" ? [[61, 109]] : [[56, 109]],
        position: "relative",
        background: ({ theme }) => theme.PageWrapperBackground,
        boxSizing: "border-box",
        maxWidth: ({ theme }) => theme.PageWrapperMaxWidth,
    },
    dynamicPageWrapper: {
        composes: "page__wrapper--dynamic",
        padding: () => 29, // It must be a function to override pageWrapper padding!
    },
    pageContent: {
        composes: "page__content",
        paddingTop: 29,
    },
    pageMessage: {
        composes: "page__message",
        textAlign: "center",
        margin: "106px 0",
        padding: 29,
        border: ({ theme }) => `${theme.BorderWidth} solid #707070`,
        borderRadius: ({ theme }) => theme.BorderRadius,
        fontSize: "1.1em",
    },
    pageHeader: {
        composes: "page__header",
        marginBottom: ({ theme }) => Mixins.getSpacing(theme, 58, 0),
        "& h1, h2, h3, h4, h5, h6": {
            margin: 0,
            padding: 0,
        },
    },
    pageHeaderLogo: {
        composes: "header__logo",
        display: "block",
        maxWidth: 250,
        maxHeight: 250,
        marginLeft: ({ theme }) => (theme.LogoAlign === "left" ? undefined : "auto"),
        marginRight: ({ theme }) => (theme.LogoAlign === "right" ? undefined : "auto"),
    },
    pageHeaderContent: {
        composes: "header__content",
        marginTop: ({ theme }) => Mixins.getSpacing(theme, 20, theme.QuestionSpacing?.WithinComponents),
        outline: "none",
    },
    pageFooter: {
        composes: "page__footer",
        "& h1, h2, h3, h4, h5, h6": {
            margin: 0,
            padding: 0,
        },
    },
    legacyBrowserWarningFloating: {
        composes: "legacy__browser__warning--floating",
        maxWidth: "450px",
        position: "fixed",
        zIndex: 2,
        margin: ["2em", 0, 0, "2em"],
    },
    legacyBrowserWarningInline: {
        composes: "legacy__browser__warning--inline",
        position: "relative",
        maxWidth: "100%",
        margin: [0, 0, "1em", 0],
    },
    legacyBrowserWarningIconContainer: {
        composes: "legacy-browser-warning__icon__container",
        position: "absolute",
        marginTop: "-25px",
        width: "100%",
        zIndex: 3,
        display: "flex",
        justifyContent: "center",
    },
    legacyBrowserWarningIconBackground: {
        composes: "legacy-browser-warning__icon__background",
        backgroundColor: "#ff9933",
        height: 46,
        width: 46,
        borderRadius: 23,
        display: "flex",
        justifyContent: "center",
    },
    legacyBrowserWarningContent: {
        composes: "legacy-browser-warning__content",
        color: ({ theme }) => Mixins.foregroundColor(theme, theme.ControlBackground),
        backgroundColor: ({ theme }) => theme.ControlBackground,
        borderRadius: ({ theme }) => theme.BorderRadius,
        padding: [15, 20],
    },
    legacyBrowserWarningEmphasis: {
        composes: "legacy-browser-warning__emphasis",
        fontWeight: "bold",
    },
    legacyBrowserWarningButton: {
        composes: "legacy-browser-warning__button",
        textAlign: "center",
        backgroundColor: ({ theme }) => theme.PrimaryColor,
        color: ({ theme }) => Mixins.foregroundColor(theme, theme.PrimaryColor),
        padding: "5px",
        borderRadius: ({ theme }) => theme.BorderRadius,
        maxWidth: "150px",
        "&:hover": {
            backgroundColor: ({ theme }) => theme.SecondaryColor,
            cursor: "pointer",
        },
    },
    backlinkContainer: {
        composes: "backlink-container",
        position: "sticky",
        bottom: 0,
        float: "right",
        padding: ["10px", "30px"],
        borderRadius: ["5px", "0", "0", "0"],
        backgroundColor: ({ theme }) => Mixins.alpha(theme.PrimaryColor, 0.4),
        color: ({ theme }) => Mixins.foregroundColor(theme, theme.PrimaryColor),
        "&:hover": {
            backgroundColor: ({ theme }) => theme.PrimaryColor,
        },
    },
    backlink: {
        composes: "backlink",
        color: ({ theme }) => Mixins.foregroundColor(theme, theme.PrimaryColor),
    },
    skiplinkContainer: {
        // https://webaim.org/techniques/css/invisiblecontent/#skipnavlinks
        composes: "skiplinkContainer",
        "& a": {
            position: "absolute",
            left: "-10000px",
            top: "auto",
            width: "1px",
            height: "1px",
            overflow: "hidden",
            "&:focus": {
                position: "static",
                width: "auto",
                height: "auto",
            },
        },
    },
});
